<!--
  Una sola estructura para los dos modos: lo único que cambia son las clases.
  (Duplicar el DOM obligaría a duplicar los <ng-content>, y Angular solo proyecta
  el contenido en el PRIMER slot que coincide: el segundo quedaría siempre vacío.)
-->
<!--
  z-[500]: por encima del sidebar (z-[70]) y de los menús flotantes (z-[200]).
  Con el z-50 anterior el panel quedaba POR DEBAJO del sidebar y aparecía cortado.
  Se queda por debajo de los avisos flotantes (z-[9999]), que sí deben verse siempre.
-->
<div *ngIf="isOpen" class="fixed inset-0 z-[500]" [class.overflow-y-auto]="!adaptable" aria-labelledby="modal-title"
    role="dialog" aria-modal="true">

    <!-- Fondo -->
    <div class="fixed inset-0 bg-slate-900 bg-opacity-75 transition-opacity" aria-hidden="true" (click)="close()"></div>

    <div [ngClass]="contenedorClases()">

        <!-- Truco de centrado vertical (solo modo clásico) -->
        <span *ngIf="!adaptable" class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <!-- Panel -->
        <div [ngClass]="panelClases()">

            <!-- Encabezado -->
            <div [ngClass]="encabezadoClases()">
                <h3 [ngClass]="tituloClases()" id="modal-title">{{ title }}</h3>
                <button type="button" [ngClass]="cerrarClases()" (click)="close()">
                    <span class="sr-only">Cerrar</span>
                    <lucide-icon name="x" [ngClass]="adaptable ? 'h-5 w-5' : 'h-6 w-6'"></lucide-icon>
                </button>
            </div>

            <!-- Contenido -->
            <div [ngClass]="cuerpoClases()">
                <ng-content></ng-content>
            </div>

            <!-- Pie -->
            <div *ngIf="showFooter" [ngClass]="pieClases()">
                <ng-content select="[modal-footer]"></ng-content>
            </div>
        </div>
    </div>
</div>
